import { useCallback } from "react";
import { useParams } from "react-router-dom";

import {
  ANALYTICS_EVENTS,
  type NavArea,
  type NavItemClickedProperties,
  type NavStep,
} from "analytics";
import { useAnalytics } from "hooks/useAnalytics";
import { useAppSidebarLayout } from "./appSidebarLayout";

interface NavClick {
  area: NavArea;
  item: string;
  step?: NavStep;
}

/** Sends `nav_item_clicked` with the sidebar's collapsed state and device. */
export function useTrackNavClick() {
  const { trackEvent } = useAnalytics();
  const { collapsed, device } = useAppSidebarLayout();
  const { workspaceId, projectId } = useParams<{ workspaceId?: string; projectId?: string }>();

  return useCallback(
    ({ area, item, step }: NavClick) => {
      trackEvent(ANALYTICS_EVENTS.NAV_ITEM_CLICKED, {
        area,
        item,
        step,
        collapsed,
        device,
        workspace_id: workspaceId,
        project_id: projectId,
      } satisfies NavItemClickedProperties);
    },
    [collapsed, device, projectId, trackEvent, workspaceId]
  );
}
